import Vue from 'vue'
import Router from 'vue-router'

import auth from '@/services/auth'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Admin views
const Assignment = () => import('@/views/assignment/Assignment')
const CleaningLogs = () => import('@/views/cleaning-logs/CleaningLogs')
const CleanerComparison = () => import('@/views/CleanerComparison')
const HistoryReport = () => import('@/views/HistoryReport')
const RatingHistory = () => import('@/views/checklist-rating/RatingHistory')
const CleanerEvents = () => import('@/views/CleanerEvents')
// Cleaner views
const Cleaning = () => import('@/views/cleaning/Cleaning')
const CleanerHistory = () => import('@/views/CleanerHistory')
const Command = () => import('@/views/Command')

// VRMS
const VehicleList = () => import('@/views/vrms/VehicleList')
const VehicleRecord = () => import('@/views/vrms/VehicleRecord')

// Views - public pages
const Page404 = () => import ('@/views/pages/Page404')
const Redirect = () => import ('@/views/pages/Redirect')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: {
            requiresAuth: true,
            module: 'VRMS',
            role: ['admin']
          }
        },
        {
          path: 'assignment',
          name: 'Assignment',
          component: Assignment,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'cleaning-logs',
          name: 'Cleaning Logs',
          component: CleaningLogs,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'cleaner-comparison',
          name: 'Cleaner Comparison',
          component: CleanerComparison,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'cleaner-history-report',
          name: 'Cleaner History Report',
          component: HistoryReport,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'checklist-rating',
          name: 'Checklist Rating',
          component: RatingHistory,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'cleaner-events',
          name: 'Cleaner Events',
          component: CleanerEvents,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'vehicle-list',
          name: 'VehicleList',
          component: VehicleList,
          meta: {
            requiresAuth: true,
            module: 'VRMS',
            role: ['admin', 'user']
          }
        },
        {
          path: 'vehicle-record',
          name: 'VehicleRecord',
          component: VehicleRecord,
          meta: {
            requiresAuth: true,
            module: 'VRMS',
            role: ['admin']
          }
        },
        {
          path: 'mrs-records',
          name: 'MRS',
          component: () => import('@/views/mrs/MRS.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'servicing-overview',
          name: 'ServicingOverview',
          component: () => import('@/views/mrs/ServicingOverview.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'mrs-workshops',
          name: 'Workshop',
          component: () => import('@/views/mrs/Workshop.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'electric-vehicles',
          name: 'ElectricVehicles',
          component: () => import('@/views/mrs/ElectricVehicles.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'electric-vehicles-config',
          name: 'ElectricVehiclesConfig',
          component: () => import('@/views/mrs/ElectricVehiclesConfig.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'vehicle-monitoring',
          name: 'VehicleMonitoring',
          component: () => import('@/views/vehicle-monitoring/VehicleMonitoring.vue'),
          meta: {
            requiresAuth: true,
            module: 'MRS',
            role: ['admin']
          }
        },
        {
          path: 'cleaning',
          name: 'Cleaning',
          component: Cleaning,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['ops-cleaning']
          }
        },
        {
          path: 'cleaner-history',
          name: 'Cleaner History',
          component: CleanerHistory,
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['ops-cleaning']
          }
        },
        {
          path: 'field-checklist/:licensePlate',
          name: 'FieldChecklist',
          component: () => import('@/views/fcs/FieldChecklist.vue'),
          meta: {
            requiresAuth: true,
            module: 'FCS',
            role: ['admin']
          }
        },
        {
          path: 'reservations',
          name: 'Reservations',
          component: () => import('@/views/reservations/Reservations.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'reservations/fleet-events/:reservationId',
          name: 'FleetEvents',
          component: () => import('@/views/reservations/FleetEvents.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'tribecar/reservations',
          name: 'TribecarReservations',
          component: () => import('@/views/tribecar/Reservations.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'tribecar/reservations/:reservationId/fleet-events',
          name: 'TribecarFleetEvents',
          component: () => import('@/views/tribecar/FleetEvents.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: 'redirect',
          name: 'Redirect',
          props: (route) => ({ query: route.query.hash }, {query: route.query.user}),
          component: Redirect,
          meta: {
            requiresAuth: false
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/pages/404'
    }
  ]
})

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// navigation guards
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.checkToken()) {
      next()
    } else {
      auth.redirect()
    }
  } else {
    next()
  }
})

export default router
